import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import userRoleService from '../../../../services/userRoleService';

const EditRole = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const [loading, setLoading] = useState(true);

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [isActive, setIsActive] = useState<boolean>(true);

  /* ================= FETCH ROLE ================= */

  useEffect(() => {
    fetchRole();
  }, []);

  const fetchRole = async () => {
    try {
      setLoading(true);
      const role = await userRoleService.getRoleById(Number(id));

      setName(role.name);
      setDescription(role.description || '');
      setIsActive(role.is_active);
    } catch (err) {
      console.error('Failed to fetch role', err);
    } finally {
      setLoading(false);
    }
  };

  /* ================= UPDATE ================= */

 const handleUpdate = async () => {
  try {
    await userRoleService.updateRole(Number(id), {
      name,
      description: description.trim() === '' ? null : description,
      is_active: isActive
    });

    navigate('/admin/roles');
  } catch (err) {
    console.error('Failed to update role', err);
  }
};


  if (loading) return <p>Loading...</p>;

  return (
    <div className="user-management">
      <div className="page-header">
        <h1>Edit Role</h1>
      </div>

      <div className="form-group">
        <label>Role Name</label>
        <input
          className="form-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>Description</label>
        <textarea
          className="form-textarea"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>Status</label>
        <select
          value={isActive ? 'active' : 'inactive'}
          onChange={(e) => setIsActive(e.target.value === 'active')}
        >
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>

      <div className="form-actions">
        <button className="btn btn-outline" onClick={() => navigate(-1)}>
          Cancel
        </button>
        <button className="btn btn-primary" onClick={handleUpdate}>
          Update Role
        </button>
      </div>
    </div>
  );
};

export default EditRole;
